import { FC, Fragment } from "react";
import {
    Text,
    Grid,
    Flex,
    Heading,
    useBreakpointValue,
} from "@smile2impress/components/relaunch";

import splitIntoColumns from "utils/clinics/splitIntoColumns";

import { ClinicGridProps } from "./ClinicGrid.types";
import { ClinicGridItem } from "./ClinicGridItem";

export const ClinicGrid: FC<ClinicGridProps> = ({
    title,
    clinics,
    showInfoText = false,
    disclaimer = "",
}) => {
    const isMobile = useBreakpointValue({
        base: true,
        tablet: true,
        desktop: false,
    });
    const [mobileCitiesColumns, desktopCitiesColumns] = splitIntoColumns(
        clinics,
        2,
        3
    );

    return (
        <>
            <Heading
                textStyle="title1"
                maxW={["100%", "100%", "800px"]}
                color="text.base"
            >
                {title}
            </Heading>
            <Grid
                templateColumns={[
                    "repeat(2, 1fr)",
                    "repeat(2, 1fr)",
                    "repeat(3, 1fr)",
                ]}
                columnGap={[2, 2, "172px"]}
                rowGap={3}
                mt={[3, 3, 4]}
            >
                {isMobile
                    ? mobileCitiesColumns.map((column, index) => (
                          <Flex
                              key={`mob-col-${index}`}
                              direction="column"
                              justifyContent="flex-start"
                              alignItems="flex-start"
                              rowGap={2}
                          >
                              {column.map((clinic) => (
                                  <Fragment
                                      key={`${clinic.title}-${clinic.id}`}
                                  >
                                      <ClinicGridItem clinic={clinic} />
                                  </Fragment>
                              ))}
                          </Flex>
                      ))
                    : desktopCitiesColumns.map((column, index) => (
                          <Flex
                              key={`desk-col-${index}`}
                              direction="column"
                              justifyContent="flex-start"
                              alignItems="flex-start"
                              rowGap={2}
                          >
                              {column.map((clinic) => (
                                  <Fragment
                                      key={`${clinic.title}-${clinic.id}`}
                                  >
                                      <ClinicGridItem clinic={clinic} />
                                  </Fragment>
                              ))}
                          </Flex>
                      ))}
            </Grid>
            {showInfoText && (
                <Text
                    textStyle="captionSmall"
                    fontStyle="italic"
                    color="base.halfBlack"
                    mt={[3, 3, 4]}
                >
                    {disclaimer}
                </Text>
            )}
        </>
    );
};
